import React from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Testimonials from "../../Testimonials";

const TestimonialsDetails = () => {
  return (
    <main className="main">
      <Testimonials />
    </main>
  );
};

export default TestimonialsDetails;
